// extracted by mini-css-extract-plugin
module.exports = {"flagItemClickable":"countryRow_flagItemClickable__3TkSp"};